export const targets = [
  {
    id: 'specialist',
    buttonText: 'Специалистам',

    leftBlock: [
      'Если вы в чем-то хорошо разбираетесь',
      'У вас есть хотя бы 1 свободный час в неделю',
      'То же самое, что консультировать знакомых и коллег, но здесь вам за это платят',
      'Вам не надо быть прикованным к монитору: консультируйте, когда удобно',
    ],

    rightBlock: [
      {
        icon: '/landing/money.png',
        iconRetina: '/landing/money@2x.png',
        title: 'Зарабатывайте на консультациях',
        description:
          'Вы сами устанавливаете стоимость вашей консультации и выбираете, когда готовы консультировать. Заработанные деньги поступают вам на банковскую карту или расчетный счет.',
      },

      {
        icon: '/landing/man-raising-hand-1-f-64-b-200-d-2642-fe-0-f.png',
        iconRetina: '/landing/man-raising-hand-1-f-64-b-200-d-2642-fe-0-f@2x.png',
        title: 'Оказывайте дополнительные услуги',
        description:
          'Подготовка документов, аудит сайта, настройка CRM-системы и многое другое может понадобиться людям после консультации за дополнительную плату.',
      },

      {
        icon: '/landing/cup-70.png',
        iconRetina: '/landing/cup-70@2x.png',
        title: 'Заработайте репутацию эксперта',
        description:
          'Получайте отзывы после каждой консультации и формируйте репутацию топового эксперта. Больше отзывов — больше клиентов.',
      },
    ],
  },

  {
    id: 'blogger',
    buttonText: 'Блогерам',

    leftBlock: [
      'Вы ведете блог в Instagram, YouTube, Facebook или на другой площадке',
      'Вы популярны, либо в чем-то хорошо разбираетесь',
      'К вам часто обращаются подписчики за советом или консультациями',
      'Вы не можете нормально всех консультировать, потому что не хотите тратить время впустую или на тех, кому это не нужно',
    ],

    rightBlock: [
      {
        icon: '/landing/expert-70.png',
        iconRetina: '/landing/expert-70@2x.png',
        title: 'Помогайте тем, кому нужно',
        description:
          'Люди, которым важны ваши знания и опыт, придут сюда, а не в комментарии или директ и будут платить за ваше внимание и время.',
      },

      {
        icon: '/landing/money.png',
        iconRetina: '/landing/money@2x.png',
        title: 'Монетизируйте аудиторию',
        description:
          'Установите любую цену консультации до 50 000 рублей, разместите ссылку у себя в соцсетях на Consulty и монетизируйте вашу аудиторию.',
      },

      {
        icon: '/landing/cup-70.png',
        iconRetina: '/landing/cup-70@2x.png',
        title: 'Подтвердите репутацию эксперта',
        description:
          'Зарабатывайте положительные отзывы, войдите в топ экспертов Consulty и получите новую регалию для подтверждения своей экспертности.',
      },

      {
        icon: '/landing/rocket-70.png',
        iconRetina: '/landing/rocket-70@2x.png',
        title: 'Продавайте основной продукт',
        description:
          'После качественной консультации многие захотят ваш основной продукт: например, купят ваш курс или обратятся в вашу компанию за товаром или услугой.',
      },
    ],
  },

  {
    id: 'business',
    buttonText: 'Бизнесу',

    leftBlock: [
      'Люди часто задают вопросы о вашем продукте: как выбрать, как сэкономить, на что обратить внимание и какие есть нюансы',
      'Вы хорошо разбираетесь в продукте и хотите помочь потенциальным клиентам',
      'Вы ищите новый канал привлечения клиентов',
      'Вы хотите получать честные отзывы за свои знания и помощь',
    ],

    rightBlock: [
      {
        icon: '/landing/money.png',
        iconRetina: '/landing/money@2x.png',
        title: 'Зарабатывайте на консультациях',
        description:
          'Вы сами устанавливаете стоимость вашей консультации и выбираете, когда готовы консультировать. Заработанные деньги поступают вам на банковскую карту или расчетный счет.',
      },

      {
        icon: '/landing/man-raising-hand-1-f-64-b-200-d-2642-fe-0-f.png',
        iconRetina: '/landing/man-raising-hand-1-f-64-b-200-d-2642-fe-0-f@2x.png',
        title: 'Оказывайте дополнительные услуги',
        description:
          'Подготовка документов, аудит сайта, настройка CRM системы и многое другое может понадобится людям после консультации за дополнительную плату.',
      },

      {
        icon: '/landing/client.png',
        iconRetina: '/landing/client@2x.png',
        title: 'Привлекайте клиентов',
        description: 'После качественной консультации многие захотят ваш основной продукт: товар или услугу.',
      },

      {
        icon: '/landing/cup-70.png',
        iconRetina: '/landing/cup-70@2x.png',
        title: 'Подтвердите репутацию эксперта',
        description:
          'Получайте отзывы после каждой консультации: они будут видны в вашем профиле Consulty. Поделитесь ссылкой с вашими клиентами - они увидят, что у вас много хороших отзывов.',
      },
    ],
  },

  {
    id: 'freelancer',
    buttonText: 'Фрилансерам',

    leftBlock: [
      'Люди часто задают вопросы о вашей услуге: как проверить ее качество, как не переплатить, что можно сделать самому, а где не обойтись без специалиста',
      'Вы хорошо разбираетесь в услуге и готовы делиться знаниями',
      'Вы ищите новый канал привлечения клиентов',
      'Вы хотите получать честные отзывы за свои знания и помощь',
    ],

    rightBlock: [
      {
        icon: '/landing/money.png',
        iconRetina: '/landing/money@2x.png',
        title: 'Зарабатывайте на консультациях',
        description:
          'Вы сами устанавливаете стоимость вашей консультации и выбираете, когда готовы консультировать. Заработанные деньги поступают вам на банковскую карту или расчетный счет.',
      },

      {
        icon: '/landing/man-raising-hand-1-f-64-b-200-d-2642-fe-0-f.png',
        iconRetina: '/landing/man-raising-hand-1-f-64-b-200-d-2642-fe-0-f@2x.png',
        title: 'Оказывайте дополнительные услуги',
        description:
          'Подготовка документов, аудит сайта, настройка CRM системы и многое другое может понадобится людям после консультации за дополнительную плату.',
      },

      {
        icon: '/landing/client.png',
        iconRetina: '/landing/client@2x.png',
        title: 'Привлекайте клиентов',
        description:
          'После качественной консультации многие захотят купить вашу услугу. Consulty разрешает обмениваться контактами!',
      },

      {
        icon: '/landing/cup-70.png',
        iconRetina: '/landing/cup-70@2x.png',
        title: 'Подтвердите репутацию эксперта',
        description: 'Поделитесь с вашими клиентами ссылкой на отзывы, которые оставят вам после каждой консультации.',
      },
    ],
  },

  {
    id: 'smm',
    buttonText: 'SMM-специалистам',

    leftBlock: [
      'Вы ведете личные или бизнес-аккаунты ваших клиентов в социальных сетях',
      'Вы хотите получать больше заявок для ваших клиентов',
      'Вы хотите сформировать для них наилучшую репутацию ',
      'Вы хотите внедрять новые инструменты для ваших клиентов и быть в тренде',
    ],

    rightBlock: [
      {
        icon: '/landing/money.png',
        iconRetina: '/landing/money@2x.png',
        title: 'Ваши клиенты заработают',
        description: 'Зарегистрируйте их в Consulty и они смогут заработать на консультациях.',
      },

      {
        icon: '/landing/client.png',
        iconRetina: '/landing/client@2x.png',
        title: 'Новые лиды для клиентов',
        description:
          'После качественной консультации многие захотят купить продукт ваших клиентов. Consulty разрешает обмениваться контактами и делиться ссылками.',
      },

      {
        icon: '/landing/cup-70.png',
        iconRetina: '/landing/cup-70@2x.png',
        title: 'Усильте репутацию клиентов',
        description:
          'Ваши клиенты смогут поделиться ссылкой на отзывы, которые оставят им после каждой консультации. У них будет сайт, подтверждающий репутацию.',
      },

      {
        icon: '/landing/money-more.png',
        iconRetina: '/landing/money-more@2x.png',
        title: 'Зарабатывайте больше',
        description:
          'Наша партнерская программа особенно выгодна SMM-специалистам. Получайте процент от платных консультаций экспертов, которых вы привели в сервис.',
      },
    ],
  },
];
